import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import React, { memo } from 'react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { bool } from 'prop-types';
import { useGetLogisticTaskIdQuery } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import openSafeLink from '../../../../../shared/utils/openSafeLink';
import config from '../../../../../shared/api/config';

const getUrl = (id) => `${config.logisticUrl}/logistic-tasks/${id}/create-report`;

function DownlandExelButton({ disabled }) {
  const params = useParams();
  const logisticTaskId = parseInt(params.logisticTaskId, 10);

  const { data: { status = null } = {} } = useGetLogisticTaskIdQuery({
    id: logisticTaskId,
  });

  const handleClick = () => {
    const token = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

    if (status === 'SOLVED') {
      openSafeLink(getUrl(logisticTaskId), { access_token: token });
    } else {
      toast.error('Действие недоступно до решения текущей задачи.');
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      startIcon={<FileDownloadIcon size="20px" color="inherit" />}
      disabled={disabled}
    >
      Выгрузить
    </Button>
  );
}

DownlandExelButton.propTypes = {
  disabled: bool.isRequired,
};

export default memo(DownlandExelButton);
